import { action, observable } from 'mobx';
import { get } from '../../../services/request';

export default class OfferNotificationStore {
  @observable list = [];
  @observable fetching = false;
  @observable succeeded = false;
  @observable failed = false;

  constructor(user, offer) {
    this.user = user;
    this.offer = offer;
  }

  @action load() {
    this.fetching = true;
    this.succeeded = false;
    this.failed = false;
    get(
      `/api/v1/notifications/${this.offer.saleId}/${this.offer.buyerId}`,
      this.user.accessToken
    ).then(this.success, this.error);
  }

  @action.bound success(data) {
    this.list = data;
    this.fetching = false;
    this.succeeded = true;
    this.failed = false;
  }

  @action.bound error(error) {
    this.fetching = false;
    this.succeeded = false;
    this.failed = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/OfferNotificationStore.js